import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { SpinLoader } from "@/components/atoms";
import ContractItem from "@/components/features/Contracts/components/ContractItem/ContractItem";
import { isNumeric } from "@/core/string";
import { contractApi } from "@/shared/apis";
import { defaultRelatedContractPagination, RelatedContractType } from "@/shared/domain";
import { StyledListEmpty } from "@/styles/styled";

// Set max, pagination not working. uncomment all these comments to re-activate pagination.
const defaultPage = { page: 1, pageSize: 256 };
// const defaultPage = { page: 1, pageSize: 5 };

type RelatedContractsProps = {
    insuredGoodId: string;
    featureType: RelatedContractType;
    ibpAclId: number;
    policyholderId: number;
};

const RelatedContracts: FC<RelatedContractsProps> = ({ insuredGoodId, featureType, ibpAclId, policyholderId }) => {
    const { t } = useTranslation();
    // const [page, setPage] = useState(defaultPage);
    const page = defaultPage;
    const isReady = isNumeric(insuredGoodId) && isNumeric(ibpAclId) && isNumeric(policyholderId);
    const { data: contractsPaginated = defaultRelatedContractPagination, isFetching } = useQuery(
        ["relatedContracts", { insuredGoodId, featureType, ...page }],
        () => contractApi.getRelatedContracts(insuredGoodId, featureType, ibpAclId, policyholderId, page),
        {
            enabled: isReady,
            suspense: false,
            keepPreviousData: true,
        },
    );

    const { result: contracts } = contractsPaginated;
    // const { result: contracts, total: totalItems } = contractsPaginated;
    // const totalOfPages = Math.ceil(totalItems / page.pageSize);

    // const handlePageSizeChange = (value: number) => {
    //     // Go back to the 1st page if page size changes
    //     setPage({ page: 1, pageSize: value });
    //     queryCache.invalidateQueries("relatedContracts");
    // };

    return (
        <div style={{ width: "100%" }} data-testid="related_contracts_list">
            {contracts.map((contract) => (
                <ContractItem key={`contractItem-${contract.id}`} contract={contract} simplified />
            ))}

            {contracts.length === 0 && !isFetching && (
                <StyledListEmpty data-testid="empty-contracts">{t("Contracts.Empty")}</StyledListEmpty>
            )}

            {isFetching && <SpinLoader />}
            {/* <Pagination
                disabled={isFetching}
                page={page.page}
                pageCount={totalOfPages}
                pageSize={page.pageSize}
                onPageChange={(value: number) => setPage({ ...page, page: value })}
                onPageSizeChange={handlePageSizeChange}
            /> */}
        </div>
    );
};

export default RelatedContracts;
